import { Cs__Soe_Dashboard_Total as ISmartMeterRaw } from "@/api/hasura/generated/graphql"
import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { DeepPartial } from "@/types/helpers"
import { ISmartMeter } from "./smartMeter.types"
import { SmartMeter } from "./smartMeter"
import { safeDayjs } from "@/helpers/dateHelper"

type SmartMeterRaw = DeepPartial<ISmartMeterRaw>

export const SmartMeterParser: IParser<ISmartMeter, SmartMeterRaw> = {
  toDomain: (data: SmartMeterRaw): ISmartMeter => {
    try {
      return new SmartMeter(
        data.dev_status ?? undefined,
        data.error ?? undefined,
        data.error_status ?? undefined,
        safeDayjs(data.installation_date),
        data.last_orchestration ?? undefined,
        data.meter_type ?? undefined,
        data.mpxn ?? undefined,
        data.msn ?? undefined,
        data.orchestration_status ?? undefined,
        data.pk ?? undefined,
        data.srv ?? undefined,
        data.latest_alert_code ?? undefined,
        data.latest_alert_status ?? undefined,
        safeDayjs(data.latest_alert_date),
        Number(data.last_reading) || undefined,
        safeDayjs(data.last_reading_date_time),
        data.workstream ?? undefined,
        data.firmware_status ?? undefined,
        data.firmware_version ?? undefined,
        data.manufacturer ?? undefined,
        data.model ?? undefined,
        data.variant ?? undefined,
        data.payment_mode ?? undefined,
        data.smets_version ?? undefined,
        data.gbcs_version ?? undefined,
        data.region ?? undefined,
        data.device_id ?? undefined,
        safeDayjs(data.ssd),
        data.comms_hub_id ?? undefined,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
